var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "global-search-container",
      on: { click: _vm.showInputModal }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.keyWord,
            expression: "keyWord"
          }
        ],
        attrs: {
          type: "text",
          name: "search",
          placeholder: _vm.$t("homePage.searchPlaceholder"),
          autocomplete: "off",
          id: "search-filed"
        },
        domProps: { value: _vm.keyWord },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.triggerSearchIfInputIsEmpty()
          },
          input: function($event) {
            if ($event.target.composing) return
            _vm.keyWord = $event.target.value
          }
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/drc/assets/icons/search_big.svg"),
          alt: "Search"
        },
        on: {
          click: function($event) {
            return _vm.triggerSearchIfInputIsEmpty()
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }